export default function () {
	const uid = [];

	for (let x = 0; x < 8; x++) {
		uid.push(((Math.random() * 16) | 0).toString(16));
	}

	return uid.join('');
}
